import React from 'react';
import { GraduationCap, Calendar, MapPin } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { useScrollAnimation } from '../hooks/useScrollAnimation';
import { usePortfolio } from '../context/PortfolioContext';

const Education = () => {
  const { education, loading } = usePortfolio();
  const [ref, isVisible] = useScrollAnimation(0.1);

  if (loading || !education.length) return null;

  return (
    <section id="education" className="py-24 md:py-32 bg-gray-50 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        {/* Section Header */}
        <div className="max-w-3xl mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            Education
          </h2>
          <p className="text-lg text-gray-700">
            Academic foundation in engineering and executive leadership development.
          </p>
        </div>

        {/* Education Grid */}
        <div ref={ref} className="grid md:grid-cols-2 gap-8">
          {education.map((edu, index) => (
            <div
              key={edu.id}
              className={`${
                isVisible ? 'animate-fade-in-up' : 'animate-on-scroll'
              }`}
              style={{ animationDelay: `${index * 150}ms` }}
            >
              <Card className="border-gray-200 hover:shadow-xl transition-all duration-500 h-full group">
                <CardContent className="p-8">
                  <div className="flex items-start gap-6">
                    {/* Logo */}
                    <div className="flex-shrink-0 w-20 h-20 bg-white rounded-xl shadow-sm flex items-center justify-center p-3 group-hover:shadow-md transition-shadow">
                      <img
                        src={edu.logo}
                        alt={edu.institution}
                        className="max-w-full max-h-full object-contain"
                      />
                    </div>

                    {/* Content */}
                    <div className="flex-1">
                      <Badge variant="secondary" className="mb-3 text-xs">
                        {edu.type}
                      </Badge>
                      <h3 className="text-xl font-semibold text-gray-900 mb-1">
                        {edu.institution}
                      </h3>
                      <p className="text-gray-700 font-medium mb-2">
                        {edu.degree}
                      </p>
                      <p className="text-sm text-gray-500 flex items-center gap-2 mb-4">
                        <Calendar size={14} />
                        {edu.duration}
                      </p>
                      <p className="text-sm text-gray-600 leading-relaxed">
                        {edu.description}
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Education;
